import buildCorrectGrammarText from "Common/componentUtils/buildCorrectGrammarText";
export default {
    LOGIN: "Логин",
    LOGIN_REQUIRED: "Введите логин!",
    USER: "Ф.И.О.",
    USERS: "Пользователи",
    ROLE: "Роль",
    ROLE_REQUIRED: "Выберите роль!",
    EMAIL: "Электронная почта",
    EMAIL_REQUIRED: "Введите почту!",
    EMAIL_INVALID: "Неправильная почта!",
    CREATE: "Создать",
    CREATED: "Дата создания",
    STATUS: "Статус",
    UNBLOCK: "Разблокировать",
    BLOCK: "Заблокировать",
    DELETE: "Удалить",
    NO_DATA_TO_SHOW: "Нет пользователей",
    PASSWORD: "Пароль",
    PASSWORD_REQUIRED: "Введите пароль!",
    REPEAT_PASSWORD: "Повторите пароль",
    PASSWORD_CONFIRMATION_IS_INVALID: "Пароли не совпадают!",
    EDITING: "Редактирование",
    CREATING: "Добавление пользователя",
    FILTER_PLACEHOLDER: "Поиск",
    getConfirmDeleteText: (count) => `Вы уверены, что хотите удалить\n${count} ${buildCorrectGrammarText(count, [
        "выбранного пользователя",
        "выбранных пользователей",
        "выбранных пользователей"
    ])}?`
};
